module.exports = __webpack_public_path__ + "img/LINK-USD.980c89e8.png";